export type RecordTableCell = {
  rowId: string;
  columnId: string;
};

export type RecordTableArrowKey =
  | "ArrowUp"
  | "ArrowDown"
  | "ArrowLeft"
  | "ArrowRight";

export function nextRecordTableCell(
  rowIds: string[],
  columnIds: string[],
  current: RecordTableCell,
  key: RecordTableArrowKey,
): RecordTableCell | null {
  const rowIndex = rowIds.indexOf(current.rowId);
  const columnIndex = columnIds.indexOf(current.columnId);
  if (rowIndex < 0 || columnIndex < 0) return null;

  const nextRowIndex =
    rowIndex + (key === "ArrowUp" ? -1 : key === "ArrowDown" ? 1 : 0);
  const nextColumnIndex =
    columnIndex + (key === "ArrowLeft" ? -1 : key === "ArrowRight" ? 1 : 0);
  const rowId = rowIds[nextRowIndex];
  const columnId = columnIds[nextColumnIndex];
  return rowId && columnId ? { rowId, columnId } : null;
}
